import { useContext } from "react";
import { type ExonnApi } from "@exonn/js-sdk";
import { ExonnApiContext } from "src/exonn-api/ExonnApiContext.ts";

let api: ExonnApi;

export const getExonnApi = (): ExonnApi => {
  if (!api) {
    throw new Error("exonn api hasn't been initialized yet");
  }
  return api;
};

export const setExonnApi = (exonnApi: ExonnApi) => {
  api = exonnApi;
};

export const useExonnApi = () => {
  const context = useContext(ExonnApiContext);
  if (!context) {
    throw new Error("useExonnApi must be used within ExonnApiProvider");
  }
  return context;
};
